<template>
  <div>
    <b-container class="mt-3">
      <b-card>
        <b-row>
          <b-col xs="12" sm="12" lg="6">
            <slot></slot>
          </b-col>

          <b-col lg="6" class="d-none d-lg-block">
            <b-card-img
              :src="image"
              img-alt="Card image"
              class="w-100 h-100"
            >
            </b-card-img>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "AuthenticationFormsContainer",
  props:{
    image: {
      type: String,
      default: require('../assets/login.png')
    }
  }
};
</script>
<style scoped>

</style>